<div class="content-wrapper" *ngIf="initializationFinished">
    <div class="row">
        <div class="col">
            <app-checkbox
                [control]="form.get('useImages')"
                inputLabel="{{ 'neuralNetwork.imageFeatureExtractor.content.useImages' | translate }}"
                (valueChange)="onUseImagesCheckboxChange($event)"
            >
            </app-checkbox>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <app-dropdown
                [control]="form.get('architectureType')"
                inputLabel="{{ 'neuralNetwork.imageFeatureExtractor.content.architectureType' | translate }}"
                [options]="supportedArchitectureTypes"
                (valueChange)="onSelectedArchitectureTypeChanged($event)"
            >
            </app-dropdown>
        </div>
        <div class="col-4">
            <app-dropdown
                [control]="form.get('pretrainedWeights')"
                inputLabel="{{ 'neuralNetwork.imageFeatureExtractor.content.pretrainedWeights' | translate }}"
                [options]="supportedPretrainedWeights"
                (valueChange)="onSelectedPretrainedWeightsChanged($event)"
            >
            </app-dropdown>
        </div>
        <div class="col-4">
            <app-algorithm-input
                [control]="form.get('compatibilityLayerSize')"
                inputLabel="{{'neuralNetwork.imageFeatureExtractor.content.compatibilityLayerSize' | translate}}"
                [allowEmptyValue]="true"
                [isFloatingPoint]="false"
                [required]="false"
                [hasSteppers]="false"
                (valueChange)="onCompatibilityLayerSizeChange()"
            >

            </app-algorithm-input>
        </div>
    </div>
</div>
